<template>
  <div class="card-form">
    <table-review ref="reviewTable" :orderCode="params.code"  @saveOkQuestion="saveOkQuestion"/>
    <div class="side-frame group-title">
      <span>{{ this.$l("form_label_title_order") || "评审处理" }}</span>
    </div>
    <order-view ref="base" :orderCode="params.code" />
  </div>
</template>
<script>
import TableReview from "../components/table-review"
import { mapActions } from "vuex"
export default {
  name: "order-orderReview-detail",
  components: { TableReview },
  data() {
    return {
      fromData: {},
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === "detail"
    },
  },
  methods: {
    ...mapActions("admin/page", ["close"]),
    onBeforeLeave() {
      return true
    },
    saveOkQuestion() {
      this.$alert(
        this.$l("INDEX.tips_save_ok") || "保存成功",
        this.$l("INDEX.tips_question_title") || "提示信息",
        {
          confirmButtonText: "确定",
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
